import { Button } from "../Actions";
import Content from "./Content";

const InitialScreen: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <Content
      title={"Minting for the First Time?"}
      description={
        <>
          We’re honored! Our mission is to level the playing field, so we’re
          going to walk you through setting up, connecting, and funding your
          wallet. We wish something like this existed for our first mint! <br />
          <br />{" "}
          <span className="w-full flex-1 mt-4">
            <span className="subhead2 text-coinage-black mb-2 block">
              Before you get started you’ll need:
            </span>{" "}
            Laptop or Desktop
          </span>
        </>
      }>
      <Button
        className="my-5"
        onClick={onClick}
        modifier="primary"
        analyticsProperty="walk me through it">
        Walk me through it
      </Button>
      <p className="body1 text-coinage-body">Estimated time: 5 minutes</p>
    </Content>
  );
};

export default InitialScreen;
